const USE_REMOTE_URL = (process.env.REACT_APP_USE_REMOTE_URL == 'true');
export const base_url = `http://localhost:8000/prod`
export const remote_base = process.env.REACT_APP_SERVERLESS_URL;
export const URL = remote_base;
